import http from "./axios";

// 查询列表
const recallMsgPage = ({
  type,
  phone,
  pageSize,
  pageNo,
  startTime,
  endTime,
  sendSuccess,
  click,
  wakeUp,
}) => {
  return http.get("/manager/sms/recallMsgPage", {
    type,
    phone,
    pageSize,
    pageNo,
    startTime,
    endTime,
    sendSuccess,
    click,
    wakeUp,
  });
};

const recallTypePage = ({ pageSize, pageNo }) => {
  return http.get("/manager/recallType/page", {
    pageSize,
    pageNo,
  });
};

const recallTypeList = () => {
  return http.get("/manager/recallType/list");
};

const sendRecallMsg = ({ type, startTime, endTime }) => {
  return http.json_post("/manager/sms/sendRecallMsg", {
    type,
    startTime,
    endTime,
  });
};

const recallTypeAdd = ({ name, domain, msgContent, path }) => {
  return http.json_post("/manager/recallType/add", {
    name,
    domain,
    msgContent,
    path,
  });
};

const recallTypeEdit = ({ id, name, domain, msgContent, path }) => {
  return http.json_post("/manager/recallType/edit", {
    id,
    name,
    domain,
    msgContent,
    path,
  });
};

const recallTypeDelete = ({ id }) => {
  return http.json_post("/manager/recallType/delete", { id });
};

export default {
  recallMsgPage,
  sendRecallMsg,
  recallTypePage,
  recallTypeList,
  recallTypeDelete,
  recallTypeAdd,
  recallTypeEdit,
};
